<template>
  <div>
    <div 
      @click="launchFile()">
      <slot name="activator"></slot>
    </div>

    <input 
      type="file"
      multiple="multiple"
      accept="image/png, image/gif, image/jpg, image/jpeg"
      ref="file"
      :name="filename"
      v-on:change="changeImage($event.target.files)"
      style="display:none">

    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar 
              color="red accent-2" 
              size="30">
              <v-icon 
                large 
                color="white">
                mdi-alert
              </v-icon>
            </v-list-item-avatar>
            
            <v-list-item-content>
              <div
                class="caption white--text">
                {{ message.error }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'upload-folder',
    data: () => ({
      dialog: false,
      filename: 'file',
      message: {
        success: '',
        error: ''
      },
      process: {
        file: false
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      changeImage (file) {
        let formData = new FormData()

        if (file.length > 0) {
          for (let i = 0; i < file.length; i++) {
            if (file[i].type != 'image/jpg' && file[i].type != 'image/jpeg' && file[i].type != 'image/png' && file[i].type != 'image/gif') {
              this.dialog = true
              this.message.error = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png / .gif'
            } else if (file[i].size > 5242880) {
              this.dialog = true
              this.message.error = 'Maksimal gambar 5MB'
            } else {
              formData.append('key', 'image')
              formData.append('image', image),
              formData.append('client_name', 'sifasum')
            }
          }

          this.process.file = true

          this.$emit('input', {
            process : this.process.file
          })

          fetch(`https://cdn-1.klaten.go.id/image.php`, {
            method: 'POST',
            body: formData
          })
          .then(res => res.json())
          .then(response => {
            this.process.file = false

            this.$emit('input', response.data)
          })
        }
      }
    }
  }
</script>